export class QueryHelper {
    public static getParameterAsNumberArray(queryParameterValue: any): number[] {
        if (Array.isArray(queryParameterValue)) {
            return queryParameterValue.map(Number);
        } else if (queryParameterValue !== undefined) {
            return [Number(queryParameterValue)];
        } else {
            return [];
        }
    }
}
